import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/shadcn/dialog";

export const Modal = (props) => {
  return (
    <Dialog open={props.open} >
      <DialogContent onClose={props.onClose} class={props.class} hideOnOutsideClick={props.hideOnOutsideClick ?? true}>
        <DialogHeader>
          <DialogTitle>{props.title}</DialogTitle>
        </DialogHeader>
        {props.children}
      </DialogContent>
    </Dialog>
  );
}
